import { Navigate, useLocation } from 'react-router-dom';
import { WORKSPACE_CANVAS_MODES } from '@/components/workspace/workspaceMode';

const EtsyOrdersPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  searchParams.set('canvas', WORKSPACE_CANVAS_MODES.etsyOrders);

  return <Navigate to={`/studio?${searchParams.toString()}`} replace />;
};

export default EtsyOrdersPage;
